import DataRemove from './container'

export default DataRemove
